export interface Supplement {
  id: string;
  name: string;
  price: number;
  description?: string;
}

export const supplements: Supplement[] = [
  { id: 'jewelry-titanium', name: 'Bijou Titane Premium', price: 25, description: 'Bijou en titane de qualité médicale' },
  { id: 'jewelry-gold', name: 'Bijou Or 14k', price: 45, description: 'Bijou en or 14 carats' },
  { id: 'aftercare-kit', name: 'Kit de Soins Complet', price: 15, description: 'Solution saline + instructions' },
  { id: 'aftercare-premium', name: 'Kit de Soins Premium', price: 25, description: 'Kit complet avec produits premium' },
  { id: 'consultation', name: 'Consultation Supplémentaire', price: 30, description: 'Consultation de suivi incluse' }
];


